import { IVerificationCodeApi } from "../interface/IForgotEmail";

interface IPhoneNumberPayload {
    msisdn: string;
    brand: string;
}

export const getStateToPayload = (phoneNumber: string, brand: string): IPhoneNumberPayload => ({
    msisdn: phoneNumber,
    brand,
});

export interface IVerificationCodeApiResponse {
    otpUuid: string;
}

export const getResponseToState = (response: IVerificationCodeApiResponse): IVerificationCodeApi => ({
    otpUuid: response.otpUuid,
});
